import React, { useEffect, useState } from "react";
import { Alert, Space, Tooltip } from "antd";

import { StepFormProps, User } from "../../types/types";
import { useIntegrations } from "../../context/integrations.context";
import { useUser } from "../../context/user.context";
import { FullPage } from "../contents/full-page";
import { BlackCard } from "../contents/black-card";
import { Connections } from "./connections";
import { Reviewing } from "./reviewing";
import { Approved } from "./approved";
import { useResponsive } from "../../utils/use-responsive";
import { Customer } from "./customer";

export const Dashboard: React.FC<StepFormProps> = (props) => {
  const { getCodatRedirect } = useIntegrations();
  const { userDetails } = useUser();
  const companyId = localStorage.getItem("companyId");
  const { isMobile } = useResponsive();

  const [user, setUser] = useState<User>({
    id: "",
    email: "",
    verified: true,
    customer: {
      id: "",
      firstname: "",
      surname: "",
      company: {
        id: "",
        name: "",
        registrationNumber: 0,
        currency: "",
        country: "",
        status: "Applied",
        offer: "pending",
        codatLink: "",
      },
    },
  });

  const userStatusInfo: any = {
    Applied: {
      title: "We have received your credit request",
      description: "We will let you know once it is being reviewed",
    },
    Reviewing: {
      title: "Your Credit is being assessed",
      description: "We will share your indicative offer once it is complete",
    },
    Approved: {
      title: "Your indicative offer is ready",
      description: "You can see the details of your offer below",
    },
    Rejected: {
      title: "Your application has been declined",
      description: "Please see below for more details",
    },
    Additional: {
      title: "Information needed",
      description: "Connect your accounts to receive an indicative offer",
    },
    Customer: {
      title: "Facility limit",
      amount: "€241,250",
      description: "€100,0000 remaining",
      tooltip:
        "This is your initial funding amount minus the €3,750.00 (1.5%) facility fee.",
    },
  };

  useEffect(() => {
    if (companyId) {
      getCodatRedirect
        .execute(companyId)
        .then((data) => {
          // setURL(data?.redirect);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    userDetails
      .execute()
      .then((data) => {
        data.customer.company.status = "Customer";
        if (data.customer.company.status == "Customer") {
          data.customer.company.offer = "drawFunds";
        }
        if (data.customer.company.status == "Approved") {
          data.customer.company.offer = "pending";
        }
        setUser(data);
      })
      .catch((error) => {
        console.log("userDetails", error);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const userProgress = userStatusInfo[user.customer.company.status];

  return (
    <FullPage user={user}>
      <Space direction={"vertical"} size={"large"} className={"full-width"}>
        <BlackCard
          title={userProgress.title}
          subtitle={userProgress.description}
          offer={user.customer.company.offer}
          amount={userProgress.amount}
          tooltip={userProgress.tooltip}
        />

        {user.customer.company.status == "Applied" && (
          <Space
            direction={"vertical"}
            size={"large"}
            className={"full-width"}
            style={{ padding: isMobile ? "0 20px 20px 20px" : 0 }}
          >
            <Alert
              message="Message here about who Codat and Plaid are"
              type="warning"
              style={{ borderRadius: "8px" }}
            />
            <Connections></Connections>
          </Space>
        )}

        {user.customer.company.status == "Reviewing" && <Reviewing></Reviewing>}

        {user.customer.company.status == "Approved" && (
          <>
            <Alert
              message="*This is an indicative offer, it is a first estimate based on the information you provided and might not be your final deal."
              type="warning"
              style={{ borderRadius: "8px" }}
            />
            <Approved></Approved>
          </>
        )}

        {user.customer.company.status == "Rejected" && (
          <Connections></Connections>
        )}

        {user.customer.company.status == "Additional" && (
          <Space
            direction={"vertical"}
            size={"large"}
            className={"full-width"}
            style={{ padding: isMobile ? "0 20px 20px 20px" : 0 }}
          >
            <Alert
              message="Message here about who Codat and Plaid are"
              type="warning"
              style={{ borderRadius: "8px" }}
            />
            <Connections></Connections>
          </Space>
        )}

        {user.customer.company.status == "Customer" && (
          <>
            <Alert
              message="Your next payment of 5,400 is due on August 1st 2024."
              type="warning"
              style={{ borderRadius: "8px" }}
            />
            <Customer></Customer>
          </>
        )}
      </Space>
    </FullPage>
  );
};
